
<template>
  <div style="margin: 0px!important" id="app">
    <Menu
      @searchBarData="getVal"
      @stitkyBarData="getVal"
      nazev="Naše kuchařka"
      obrazek="obr/logo.png"
      :stitky="stitky"
    ></Menu>
    <div v-show="this.$route.path==='/'" class="row" id="recepty">
      <Card
        class="col-xs-5 col-sm-6 col-lg-3"
        style="padding: 0px!important"
        v-for="(card, index) in filter"
        :key="index"
        :porce="card.porce"
        :dobaPripravy="card.doba"
        :nazev="card.nazev"
        :stitky="card.stitky"
        :obrazek="card.obrazek"
        :suroviny="card.suroviny"
        :koreni="card.koreni"
        :id="card.id"
      />
    </div>
    <router-view :recepty="config"></router-view>
  </div>
</template>

<script>
Array.prototype.inArray = function(comparer) {
  for (var i = 0; i < this.length; i++) {
    if (comparer(this[i])) return true;
  }
  return false;
};

// adds an element to the array if it does not already exist using a comparer
// function
Array.prototype.pushIfNotExist = function(element, comparer) {
  if (!this.inArray(comparer)) {
    this.push(element);
  }
};

import axios from "axios";
import Card from "./components/card.vue";
import Menu from "./components/menu.vue";

export default {
  name: "app",
  components: {
    Card,
    Menu
  },
  data: () => {
    return {
      config: [],
      stitkysearch: [],
      errors: [],
      stitky: [],
      search: ""
    };
  },
  created() {
    axios
      .get(`https://kucharka.zvara.cz/getrecepts.php`) //https://kucharka.zvara.cz/getrecepts.php
      .then(response => {
        console.log(response);
        // JSON responses are automatically parsed.
        let tmp = [];
        let data;
        if (typeof response.data === "string") {
          let index = 0;
          for(var i = 0; i < response.data.length; i++){
            if( response.data.charAt(i) === "["){
              index = i;
              break;
            };
          }
          data = JSON.parse(response.data.slice(index));
          console.log(data);
          
        } else {
          console.log("fail");
          data = response.data;
        }

       data.forEach((element, index) => {
          element.id = index.toString();
          tmp.push(element);
        });
        this.config = tmp;
        console.log(tmp);
        console.log("test");
        let ret = [];
        this.stitky = ret;
        this.config.forEach(element => {
          element.stitky.forEach(element2 => {
            let pushable = true;
            ret.some(el => {
              if (
                el.name
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "") ===
                element2
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              )
                pushable = false;
              return !pushable;
            });
            if (pushable) ret.push({ name: element2 });
          });
        });
      })
      .catch(e => {
        console.log("chyba " + e);
        console.log(e);
        this.errors.push(e);
      });
  },
  methods: {
    getVal: function(val) {
      if (typeof val === "object") this.stitkysearch = val;
      else if (typeof val === "string") this.search = val;
    }
  },
  computed: {
    filter() {
      return this.config.filter(item => {
        if (this.stitkysearch.length === 0)
          return (
            item.nazev.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        else {
          let stitky = true;
          this.stitkysearch.forEach(stitek => {
            stitky = stitky && item.stitky.includes(stitek.name);
          });
          return (
            item.nazev.toLowerCase().indexOf(this.search.toLowerCase()) > -1 &&
            stitky
          );
        }
      });
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
